import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { convertToEasternISO, formatDateYMD, getDateDaysAgo } from '../../../../utils/dateFormatter'
import { getGameReportStart } from '../../../../store/redux-slices/dashboard'
import { getLoginToken } from '../../../../utils/storageUtils'
import useDidMountEffect from '../../../../utils/useDidMountEffect'

const useTopPlayers = ({ selectedPortal, selectedClient }) => {
  const dispatch = useDispatch()
  const { gameReportLoading: loading, gameReport } = useSelector((state) => state.dashboard)
  const [selectedTab, setSelectedTab] = useState('game')
  const [search, setSearch] = useState('')
  const [dateOptions, setDateOptions] = useState('')
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(20)
  const isInitialRender = useDidMountEffect()
  const totalPages = Math.ceil(gameReport?.count / limit)

  const [state, setState] = useState([
    {
      startDate: getDateDaysAgo(0),
      endDate: new Date(),
      key: 'selection'
    }
  ])

  const fetchDetails = (data) => {
    const startDate = convertToEasternISO(
      data?.action === "refresh"
        ? getDateDaysAgo(0)
        : state?.map((a) => a.startDate)
    );
    const endDate = convertToEasternISO(
      data?.action === "refresh" ? new Date() : state?.map((a) => a.endDate)
    );
    const searchString = data?.action === "refresh" ? "" : search;
    const date_options = data?.action === "refresh" ? "" : dateOptions;

    dispatch(getGameReportStart({
      isTenant: false,
      startDate,
      endDate,
      tenantId: selectedPortal,
      adminId: selectedClient,
      dateOptions: date_options,
      selectedTab,
      search: searchString,
      page,
      limit
    }))
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          fetchDetails()
        } else {
          setPage(1)
        }
      }
    }, 1000)
    return () => clearTimeout(delayDebounceFn)
  }, [state, selectedClient, selectedPortal, selectedTab, dateOptions, search, limit])

  useEffect(() => {
    if (!isInitialRender) fetchDetails()
  }, [page])

  useEffect(() => {
    fetchDetails()
  }, [])

  const getCsvDownloadUrl = () =>
    `${process.env.REACT_APP_API_URL}/api/admin/casino/fetch-game-reports?search=${search}&date=${dateOptions}&csvDownload=true&token=${getLoginToken()}`

  // const handleResetFilters = useCallback(() => {
  //   setSearch('')
  //   setDateOptions('')
  //   setState([{
  //     startDate: getDateDaysAgo(0),
  //     endDate: new Date(),
  //     key: "selection",
  //   }])

  //   fetchDetails({ action: 'refresh' })
  // }, [])

  const handleResetFilters = useCallback(() => {
    search !== "" && setSearch('')
    dateOptions !== "" && setDateOptions('')
    if (search === "" && dateOptions === "") {
      fetchDetails({ action: 'refresh' })

    }
  }, [search, dateOptions])


  return {

    fetchDetails,
    loading,
    setState,
    state,
    selectedTab,
    setSelectedTab,
    gameReport,
    limit,
    setLimit,
    dateOptions,
    setDateOptions,
    getCsvDownloadUrl,
    search,
    setSearch,
    limit,
    setLimit,
    page,
    setPage,
    totalPages,
    handleResetFilters
  }
}

export default useTopPlayers
